import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class CreateAvverkningskostnaderCommand extends BasicCommand<CreateAvverkningskostnaderCommand> {

    virkeskopskontraktGUID: string;
    virkeskopsatgardGUID: string;
    mattslag: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateAvverkningskostnaderCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "avverkningskostnader";

    get primaryKey(): IPrimaryKey<CreateAvverkningskostnaderCommand> {
        return {
            atgardGuid: this.virkeskopsatgardGUID
        };
    }

    constructor(virkeskopskontraktGUID: string, virkeskopsatgardGUID: string, mattslag: string) {
        super(CreateAvverkningskostnaderCommand.$type, CreateAvverkningskostnaderCommand.$groupKey, CommandType.Insert);
        this.virkeskopskontraktGUID = virkeskopskontraktGUID;
        this.virkeskopsatgardGUID = virkeskopsatgardGUID;
        this.mattslag = mattslag;
    }
}
